import React, { useMemo } from "react";
import DetailsTable from "./DetailsTable";
import DetailsSectionLabel from "./DetailsSectionLabel";

export default function DetailsTab({ data }) {
  const detailsItems = useMemo(
    () => [
      { label: "Township", key: "TownshipName" },
      { label: "Tax Code", key: "TaxCode" },
      { label: "Tax Status", key: "TaxStatus" },
      { label: "Property Class", key: "PropertyClass" },
      { label: "Assessed Value", key: "AssessedValue", hideCurrentYear: true },
      { label: "Net Taxable Value", key: "NetTaxableValue", hideCurrentYear: true },
      { label: "Tax Rate", key: "TaxRate", hideCurrentYear: true },
      { label: "Total Tax", key: "TotalTax", hideCurrentYear: true },
    ],
    []
  );

  const relatedNamesColumns = useMemo(
    () => [
      { label: "Name", key: "Name" },
      { label: "Relationship", key: "Relationship" },
    ],
    []
  );

  return (
    <>
      <DetailsSectionLabel label="PARCEL DETAILS" isFirst={true} />
      {detailsItems.map((item) => {
        let value = data[item.key];
        if (item.hideCurrentYear && new Date().getFullYear() === data.Year) {
          // If the current year is selected, we want to show "Unavailable" for certain fields
          value = "Unavailable";
        }
        return (
          <div key={item.key} className="flex text-xs text-center">
            <b className="text-right">{item.label}:</b>
            <span className="ml-2">{value}</span>
          </div>
        )
      })}
      <DetailsSectionLabel label="SITE ADDRESS" />
      <div className="flex text-xs text-center">
        <span className="ml-2">{data.SiteAddress}</span>
      </div>
      <DetailsSectionLabel label="RELATED NAMES" />
      <DetailsTable rows={data.RelatedNames} columns={relatedNamesColumns} />
    </>
  );
}
